import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './RoadsideBlock.module.scss';

const RoadsideBlock = ({ data }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  const imageUrl = getImageUrl(data?.image);
  const title = data?.title || '';
  const content = data?.text || '';
  const termsUrl = data?.termsUrl || '';
  const buttonText = data?.buttonText || '';

  return (
    <div className={styles.wrapper} data-aos="fade-up">
      <div className={styles.image}>
        <img alt="Roadside assistance" src={imageUrl} />
      </div>
      <div className={styles.content}>
        <div dangerouslySetInnerHTML={{ __html: title }} />
        <div dangerouslySetInnerHTML={{ __html: content }} />
        {buttonText && (
          <div className={styles.content_buttonContainer}>
            <a
              href={termsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.content_buttonContainer_button}
            >
              {buttonText}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoadsideBlock;
